export enum CourtEventNoteSaveActionTypes {
    SaveCourtEventNote = '[CourtEventNoteSave] Save court event note',
    SaveCourtEventNoteSuccess = '[CourtEventNoteSave] Save court event note success',
    ResetCourtEventNoteForm = '[CourtEventNoteSave] Reset court event note form'
}

export class SaveCourtEventNoteAction {
    static type = CourtEventNoteSaveActionTypes.SaveCourtEventNote;

    constructor(public courtEventId: string) { }
}

export class SaveCourtEventNoteSuccessAction {
    static type = CourtEventNoteSaveActionTypes.SaveCourtEventNoteSuccess;
}

export class ResetCourtEventNoteFormAction {
    static type = CourtEventNoteSaveActionTypes.ResetCourtEventNoteForm;
}

